import React from 'react';

const classes = {
  default: {
    button: 'w-full flex items-center px-2.5 py-2 rounded whitespace-nowrap',
    svg: 'w-4 h-4 shrink-0 fill-current text-slate-400 dark:text-slate-500 mr-2',
    span: 'text-sm font-medium text-slate-600 dark:text-slate-300',
  },
  active: {
    button:
      'w-full flex items-center px-2.5 py-2 rounded whitespace-nowrap bg-white dark:bg-slate-800',
    svg: 'w-4 h-4 shrink-0 fill-current text-indigo-500 mr-2',
    span: 'text-sm font-medium text-indigo-500',
  },
};

export default function SidebarButton({ section, isActive, onClick }) {
  return (
    <div>
      <li className="mr-0.5 md:mr-0 md:mb-0.5">
        <button
          type="button"
          className={isActive ? classes.active.button : classes.default.button}
          onClick={onClick}
          tabIndex={-1}
        >
          <svg
            className={isActive ? classes.active.svg : classes.default.svg}
            viewBox="0 0 16 16"
          >
            {section.svgPath}
          </svg>
          <span
            className={` truncate ${
              isActive ? classes.active.span : classes.default.span
            }`}
          >
            {section.displayTitle || section.title}
          </span>
        </button>
      </li>
    </div>
  );
}
